export default [
  {
    media: {
      icon: ['fas', 'robot'],
      color: 'primary',
      className: ''
    },
    title: 'AI Operations Automation',
    description:
      'We find the manual work slowing the business down, then build AI agents and automations inside the workflows your team already uses.',
    features: [
      'Finance, admin, and reporting workflows',
      'Email, spreadsheet, and data-entry automation',
      'AI-assisted customer and vendor operations',
      'Dashboards that show ROI in operating terms'
    ],
    iconClass: 'finance'
  },
  {
    media: { icon: ['fas', 'store'], color: 'warning', className: '' },
    title: 'Marketplace & Ecommerce Infrastructure',
    description:
      'We stand up the channels, feeds, listings, inventory logic, and operating cadence required to sell across modern marketplaces.',
    features: [
      'Amazon, Walmart.com, Shopify, TikTok Shop, and more',
      'Channel launch and marketplace operations',
      'Inventory sync, listing QA, and issue resolution',
      'Reporting rhythms your team can keep running'
    ],
    iconClass: 'ecommerce'
  },
  {
    media: { icon: ['fas', 'box-open'], color: 'info', className: '' },
    title: 'Catalog & Product Data Systems',
    description:
      'We turn legacy product data into channel-ready assets, with enrichment, cleanup, normalization, and governance built into the process.',
    features: [
      'SKU cleanup and catalog normalization',
      'AI product enrichment and descriptions',
      'Image, attribute, and taxonomy readiness',
      'Pricing, margin, and competitive intelligence'
    ],
    iconClass: 'product'
  },
  {
    media: { icon: ['fas', 'people-arrows'], color: 'success', className: '' },
    title: 'Change Management & Team Adoption',
    description:
      'We embed with your people, train the team, document the systems, and stay close enough to make the new operating model stick.',
    features: [
      'Principal-led implementation, not junior handoff',
      'SOPs, training, and operating cadence',
      'Legacy system and ERP integration support',
      'Ongoing optimization after launch'
    ],
    iconClass: 'fullstack'
  }
];
